export const pluralizeOfferLabel = (n: number): string => (n === 1 ? 'объявление' : 'объявлений');
